import React from 'react';

import { Box } from '../Box';
import { ExternalLink } from '../Styled';
import { Typography } from '../Typography';
import { Wrapper } from './styled';

export const ErrorWithHelpLink = () => (
  <Box height='100vh' width='100vw' display='flex' justifyContent='center' alignItems='center' textAlign='center'>
    <Wrapper>
      <Typography>Кажется, у нас проблема 🤔</Typography>
      {/*ТГ нашего ПМ-а*/}
      <ExternalLink href='https://t.me/help_sdlife' target='_blank'>
        <Typography>Помогу решить</Typography>
      </ExternalLink>
    </Wrapper>
  </Box>
);
